import { faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { viewBrand } from "../../redux/features/brands/brandsSlice";

function ViewBrand({ brandId }) {
  const dispatch = useDispatch();
  const { selectedBrand, viewBrandLoading } = useSelector(
    (state) => state.brands,
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    logo: null,
  });
  const handleOpen = () => {
    setIsModalOpen(true);
    dispatch(viewBrand(brandId));
  };
  const handleClose = () => setIsModalOpen(false);

  useEffect(() => {
    if (selectedBrand) {
      const { id, name, logo } = selectedBrand;
      setFormData({ id, name, logo });
    }
  }, [selectedBrand]);

  return (
    <div>
      <button
        onClick={handleOpen}
        className="text-blue-500 hover:text-blue-700 font-medium"
      >
        <FontAwesomeIcon icon={faEye} />
      </button>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-[45%] p-10 relative">
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <h2 className="text-xl font-semibold border-b border-gray-200 mb-6 pb-5 text-left">
              View Brand
            </h2>

            {viewBrandLoading ? (
              <div className="text-center py-10 text-gray-500 font-medium text-2xl animate-pulse">
                Loading...
              </div>
            ) : (
              <form className="space-y-10">
                <div className="grid grid-cols-1 gap-5">
                  <div>
                    <label className="block text-gray-700 font-medium mb-1 text-left">
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      readOnly
                      className="w-full border border-gray-300 rounded-md p-2 bg-gray-100 cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-1 text-left">
                      Logo
                    </label>
                    <div className="py-5 border border-gray-300 rounded-lg bg-gray-100 flex justify-center">
                      <img
                        src={selectedBrand?.logo}
                        alt={selectedBrand?.name}
                        className="h-[9vw] w-[13vw] rounded-lg"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                  <button
                    type="button"
                    onClick={handleClose}
                    className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100"
                  >
                    Close
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewBrand;
